import React from "react";
import { Switch, Route, Redirect, Link } from "react-router-dom";
import DashBoardPage from "../Pages/MainPages/Dashboard";
import WizardFormPage from "../Pages/MainPages/WizardForm";
import WizardEditFormPage from "../Pages/MainPages/WizardEditForm";
import WizardRotulosFormPage from "../Pages/MainPages/WizardRotulosForm";
import WizardRotulosEditFormPage from "../Pages/MainPages/WizardRotulosEditForm";
import UserListPage from "../Pages/UserListPage/user_list_page";
import PedidosAjudaPage from "../components/HelpDesk/PedidosAjudaPage";
import ReclamacoesSugestoesPage from "../components/ReclamacoesSugestoes/ReclamacoesSugestoesPage";
import CreateUserPage from "../Pages/UserListPage/create_user_page";
import AdminDashboardAudit from "../Pages/MainPages/AdminDashboardAudit";
import AdminDashboardGroupPage from "../Pages/Group/AdminDashboardGroup";
import AdminDashboardGroupUserPage from "../Pages/Group/AdminDashboardGroupUser";
import AdminDashboardPermissions from "../Pages/Group/AdminDashboardPermissions";
import ContaDashbaord from "../Pages/MainPages/ContaDashbaord";
import ContaOperationContainer from "../Pages/ContaModule/ContaOperationContainer";
import RuleForm from "../Pages/ContaModule/RuleForm";
import Nivel2Tabs from "../components/ContaModule/RegrasForms/Nivel2Tabs";
import RegistoContainer from "../Pages/RegistoPage/RegistoContainer";
import Schedule from "../Pages/MainPages/Schedule";
import ScheduleDetailPage from "../Pages/SchedulePage/schedule_detail_page";
import ScheduleCalenderPage from "../Pages/SchedulePage/schedule_calender_page";
import CreateSchedulePage from "../Pages/SchedulePage/create_schedule";

import DemoTable from "../Pages/Demo/table";
import EstotusListPage from "../Pages/EstotusPage/estotus_list_page";
import EstatosDetailPage from "../Pages/EstotusPage/estotus_detail_page";
import EntityRuleListPage from "../Pages/EntityRule/entity_rule_list_page";
import EntityRuleFormPage from "../Pages/EntityRule/entity_rule_form_page";
import VidimaMainPage from "../Pages/VidimaModule/vidima_Conta_de_Produtor_page";
import TesourariaReceitas from "../Pages/modules/Revenue/TesourariaReceitas";
import TesourariaConta from "../Pages/modules/Revenue/TesourariaConta";
import TesourariaFaturas from "../Pages/modules/Revenue/TesourariaFaturas";
import VindimaAutorizacaoPage from "../Pages/VidimaModule/vindima_Autorização_page";
import VindimaRegistoPage from "../Pages/VidimaModule/vindima_Registo_page";
import VindimaDeclaracaoPage from "../Pages/VidimaModule/vindima_Declaração_page";
import VindimaReportPage from "../Pages/VidimaModule/vindima_report_page";
import VindimaSecondScreenComponent from "../components/VidimaModule/vindimaSecondScreenComponent";

import ReceitasSecondScreen from "../Pages/modules/Revenue/ReceitasSecondScreen";
import RecaboDeAdiantamento from "../Pages/modules/Revenue/RecaboDeAdiantamento";
import Cashier from "../Pages/modules/Revenue/Cashier";
import GeneralAccount from "../Pages/modules/Revenue/GeneralAccount";
import TesourariaGerfip from "../Pages/modules/Revenue/TesourariaGerfip";
import Penhoras from "../Pages/modules/Revenue/Penhoras";
import NIBs from "../Pages/modules/Revenue/NIBs";
import CriacaoPenhora from "../Pages/modules/Revenue/CriacaoPenhora";
import CriacaoNIBS from "../Pages/modules/Revenue/CriacaoNIBS";

import InstalaCaovinica from "../Pages/modules/instalacaovinica/InstalaCaovinica";
import InstalaçõesInsert from "../Pages/modules/instalacaovinica/InstalaçõesInsert";
import InserirInstalacaoVínica from "../Pages/modules/instalacaovinica/InserirInstalacaoVínica";

import Boletim from "../Pages/MainPages/Boletim";
import Boletim_form from "../Pages/MainPages/Boletim_form";

import Rotulos from "../Pages/modules/rotulos/RotulosTotal";
import RotulosPendentes from "../Pages/modules/rotulos/RotulosPendentes";
import RotulosOneAvaliação from "../Pages/modules/rotulos/RotulosOneAvaliação";
import RotulosTwoAvaliação from "../Pages/modules/rotulos/RotulosTwoAvaliação";
import ProcessosScreen from "../Pages/modules/rotulos/ProcessosScreen";
import MarcaScreen from "../Pages/modules/rotulos/MarcaScreen";
import RotulosNDProcesso from "../Pages/Rotulos/RotulosNDProcesso";
import SelosPedidos from "../Pages/modules/selos/SelosPedidos";
import SelosTodosPedido from "../Pages/modules/selos/SelosTodosPedido";
import SelosRequisicao from "../Pages/modules/selos/SelosRequisicao";
import SelosRastreabilidade from "../Pages/modules/selos/SelosRastreabilidade";
import SelosAposicao from "../Pages/modules/selos/SelosAposicao";
import MarcasPedidos from "../Pages/modules/marcas/MarcasPedidos";
import MarcasNProcesso from "../Pages/modules/marcas/MarcasPopup";
import MarcasHistory from "../Pages/modules/marcas/MarcasHistory";
import MarcasApproved from "../Pages/modules/marcas/MarcasApproved";
import InsertFormVinica from "../Pages/modules/instalacaovinica/InsertFormVinica";
import AgendaDigital from "../Pages/MainPages/AgendaDigital";
import DetalhesTransferencias from "../Pages/Rotulos/DetalhesTranferencias";

import FiscalizacaoHistory from "../Pages/modules/fiscalizacao/FiscalizacaoPendentes";
import FiscalizacaoPendentes from "../Pages/modules/fiscalizacao/FiscalizacaoPendentes";
import FiscalizacaoConcluidos from "../Pages/modules/fiscalizacao/FiscalizacaoConcluidos";
import FiscalizacaoInsercaoSelosEtiquetas from "../Pages/modules/fiscalizacao/FiscalizacaoInsercaoSelosEtiquetas";
import FiscalizacaoRS from "../Pages/modules/fiscalizacao/FiscalizacaoRS";
import FiscalizacaoAgendamento from "../Pages/modules/fiscalizacao/FiscalizacaoAgendamento";
import FiscalizacaoRequisicaoPrevia from "../Pages/modules/fiscalizacao/FiscalizacaoRequisicaoPrevia";
import InserirFiscalizacao  from "../Pages/modules/fiscalizacao/InserirFiscalizacao"
import EditFrases from "../components/FrasesPersonalizadas/EditFrases";
import EditPedidoAjuda from "../components/HelpDesk/EditPedidoAjuda";
import NewPedidoAjuda from "../components/HelpDesk/NewPedidoAjuda";
import NewSugestaoReclamacao from "../components/ReclamacoesSugestoes/NewSugestaoReclamacao";
import DetailsPedidoAjuda from "../components/HelpDesk/DetailsPedidoAjuda";
import DetailsSugestoesReclamacoes from "../components/ReclamacoesSugestoes/DetailsSugestoesReclamacoes";
import CriacaoReceita from "../Pages/modules/Revenue/CriacaoReceita"
import FrasesPage from "../components/FrasesPersonalizadas/FrasesPage";
import NotificacoesPage from "../components/Notificacoes/NotificacoesPage";
import GestaoRSPage from "../components/GestaoRS/GestaoRSPage";
import EditCampos from "../components/GestaoRS/EditCampos";
const NotFoundPage = (props) => {
    return (
        <>
            <div className="d-flex flex-column justify-content-center align-items-center border">
                <h1>404 - Not Found!</h1>
                <Link to="/">Go Home</Link>
            </div>
        </>
    );
};

class AppSwitch extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Switch>
                <Route
                    exact
                    path="/"
                    render={() => <Redirect to="/agenda_digital" />}
                />
                <Route exact path="/dashboard" component={DashBoardPage} />

                <Route path="/agenda_digital" component={AgendaDigital} />

                <Route path='/portalviticultor' component={() => {
                    // window.location.href = 'https://sigrdd.ivdp.pt/IVDP/webapp/';
                    window.open('https://sigrdd.ivdp.pt/IVDP/webapp/', '_blank');
                    window.location.replace('/agenda_digital')
                    return null;
                    
                }} />

                <Route path="/wizard_form" component={WizardFormPage} />
                <Route
                    path="/wizard_edit_form"
                    component={WizardEditFormPage}
                />

                <Route path="/user_list" component={UserListPage} />
                <Route path="/HelpDesk" component={PedidosAjudaPage}/>
                <Route path="/Reclamacoes_Sugestoes" component={ReclamacoesSugestoesPage}/>
                <Route path="/create_user" component={CreateUserPage} />
                {/* <Route path='/create_user?:id' component={CreateUserPage} /> */}

                <Route
                    path="/admin_dashboard_estato"
                    component={EstotusListPage}
                />
                <Route path="/admin_dashboard_frases" component={FrasesPage}/>
                <Route path="/admin_dashboard_notificacoes" component={NotificacoesPage}/>
                <Route path="/admin_dashboard_gestaors" component={GestaoRSPage}/>
                <Route path="/estato_detail" component={EstatosDetailPage} />
                <Route path="/frases_detail" component={EditFrases} />
                <Route path="/pedidoAjuda_detail" component={DetailsPedidoAjuda} />
                <Route path="/sugestoesReclamacoes_detail" component={DetailsSugestoesReclamacoes} />
                <Route path="/pedidoAjuda_edit" component={EditPedidoAjuda} />
                <Route path="/pedidoAjuda_novo" component={NewPedidoAjuda} />
                <Route path="/SugestaoReclamacao_novo" component={NewSugestaoReclamacao} />
                <Route path="/InserirNovoCampoRS" component={EditCampos} />
                <Route
                    path="/entity_rule_list"
                    component={EntityRuleListPage}
                />
                <Route
                    path="/entity_rule_form"
                    component={EntityRuleFormPage}
                />

                <Route
                    path="/admin_dashboard_audit"
                    component={AdminDashboardAudit}
                />

                <Route
                    path="/admin_dashboard_groups"
                    component={AdminDashboardGroupPage}
                />
                <Route
                    path="/admin_dashboard_group_user/:name/:id"
                    component={AdminDashboardGroupUserPage}
                />
                <Route
                    path="/admin_dashboard_permissions/:name/:id"
                    component={AdminDashboardPermissions}
                />

                <Route path="/schedule" component={Schedule} />
                <Route path="/schedule_detail" component={ScheduleDetailPage} />
                <Route
                    path="/schedule_calender_show"
                    component={ScheduleCalenderPage}
                />
                <Route path="/create_schedule" component={CreateSchedulePage} />
                <Route
                    path="/create_schedule/:id"
                    component={CreateSchedulePage}
                />
                <Route path="/admin_demo" component={DemoTable} />

                {/* Vidima Routes  */}
                <Route
                    path="/vindima_Conta_de_Produtor"
                    component={VidimaMainPage}
                />
                <Route
                    path="/vindima_authorizacao"
                    component={VindimaAutorizacaoPage}
                />
                <Route path="/vindima_registo" component={VindimaRegistoPage} />
                <Route
                    path="/vindima_declaracao"
                    component={VindimaDeclaracaoPage}
                />
                <Route path="/vindima_report" component={VindimaReportPage} />
                <Route
                    path="/vindima_page"
                    component={VindimaSecondScreenComponent}
                />

                {/* Conta Routes */}
                <Route path="/conta_corrente" component={ContaDashbaord} />
                <Route
                    path="/conta_operações"
                    component={ContaOperationContainer}
                />
                <Route path="/conta_regras_form" component={RuleForm} />
                <Route path="/conta_regras_form/gestaoRegras" component={Nivel2Tabs} />

                {/*Registo*/}
                <Route path="/registo" component={RegistoContainer}/>

                {/*Revenue*/}
                <Route
                    path="/revenue_receitas" component={TesourariaReceitas}
                />
                <Route path="/revenue_criacao" component={CriacaoReceita} />
                <Route path="/revenue_conta" component={TesourariaConta} />
                <Route path="/revenue_faturas" component={TesourariaFaturas} />
                <Route path="/revenue_page" component={ReceitasSecondScreen} />
                <Route
                    path="/recabo_de_adiantamento"
                    component={RecaboDeAdiantamento}
                />
                <Route path="/cashier" component={Cashier} />
                <Route path="/gerfip" component={TesourariaGerfip} />
                <Route path="/general_account" component={GeneralAccount} />

                <Route path="/penhoras" component={Penhoras}/>
                <Route path="/Conta" component={NIBs}/>
                <Route path="/criacao_penhora" component={CriacaoPenhora} />
                <Route path="/criacao_Conta" component={CriacaoNIBS} />
                
                {/*instalacaovinica*/}
                <Route path="/instalacaovinica" component={InstalaCaovinica} />
                <Route
                    path="/instalaçõesinsert"
                    component={InstalaçõesInsert}
                />
                {/* <Route path="/insertVinica" component={InsertFormVinica} /> */}
                <Route
                    path="/inseririnstalacaovínica"
                    component={InserirInstalacaoVínica}
                />

                {/* Selos */}
                <Route path="/selos_pedidos" component={SelosPedidos} />
                <Route path="/selosTodosPedidos"component={SelosTodosPedido}/>
                <Route path="/selos_requisicao" component={SelosRequisicao} />
                <Route path="/selos_rastreabilidade" component={SelosRastreabilidade} />
                <Route path="/aposicao_de_selos" component={SelosAposicao} />

                {/* Marcas */}
                <Route path="/marcasPendentes" component={MarcasPedidos} />
                <Route path="/marcasHistory" component={MarcasHistory} />
                <Route path="/marcasApproved" component={MarcasApproved} />
                <Route
                    path="/marcas_n_d_processo"
                    component={MarcasNProcesso}
                />
                {/* Fiscalizacao */}
                <Route path="/fiscalizacao" component={FiscalizacaoHistory} />
                <Route path="/fiscalizacaoConcluidos" component={FiscalizacaoConcluidos} />
                <Route path="/FiscalizacaoInsercaoSelosEtiquetas" component={FiscalizacaoInsercaoSelosEtiquetas} />
                <Route path="/FiscalizacaoRS" component={FiscalizacaoRS} />
                <Route path="/inserirFiscalizacao" component={InserirFiscalizacao} />
                <Route path= "/FiscalizacaoAgendamento" component={FiscalizacaoAgendamento} />
                <Route path= "/FiscalizacaoRequisicaoPrevia" component={FiscalizacaoRequisicaoPrevia} />
                <Route
                    path="/marcas_n_d_processo"
                    component={MarcasNProcesso}
                />
                {/* boletin */}
                <Route exact path="/boletim" component={Boletim} />
                <Route path="/boletim_form" component={Boletim_form} />

                {/*rotulos*/}
                <Route path="/n_d_processo" component={RotulosNDProcesso} />
                <Route path="/rotulos" component={Rotulos} />
                <Route path="/rutulo_processos" component={ProcessosScreen} />
                <Route path="/minhas_avaliações" component={MarcaScreen} />
                <Route path="/Detalhes_Transferencia" component={DetalhesTransferencias} />
                {/* <Route path='/rotulos_pendentes' component={RotulosPendentes}/>
                <Route path='/rotulos_one_avaliação' component={RotulosOneAvaliação}/>
                <Route path='/rotulos_two_avaliação' component={RotulosTwoAvaliação}/>    */}

                <Route
                    path="/wizard_rotulos_form"
                    component={WizardRotulosFormPage}
                />
                <Route
                    path="/wizard_rotulos_edit_form"
                    component={WizardRotulosEditFormPage}
                />
                <Route render={(props) => <NotFoundPage {...props} />} />
            </Switch>
        );
    }
}

export default AppSwitch;
